"use client";

import * as React from "react";

import { Button } from "../Button";
// @ts-expect-error - Icon is a JSX component without TypeScript definitions
import { Icon } from "../../UIElements/Icon";
import { Calendar } from "../Calendar";
import { Label } from "../Label";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover";

interface DatePickerProps {
  value?: Date;
  onChange?: (date: Date | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  className?: string;
  label?: string;
  id?: string;
}

function DatePicker({
  value,
  onChange,
  placeholder = "Select date",
  disabled = false,
  error = false,
  className = "",
  label,
  id = "date-picker",
  ...props
}: DatePickerProps) {
  const [open, setOpen] = React.useState(false);

  const handleSelect = (date: Date | undefined) => {
    onChange?.(date);
    setOpen(false);
  };

  return (
    <div className="flex flex-col gap-3">
      {label && (
        <Label htmlFor={id} className="px-1">
          {label}
        </Label>
      )}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outlineLight"
            id={id}
            disabled={disabled}
            className={`h-9 w-full justify-between font-normal ${
              error ? "border-red-500" : ""
            } ${className}`}
            {...props}
          >
            {value ? value.toLocaleDateString() : placeholder}
            <Icon name="ChevronDown" className="h-4 w-4 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto overflow-hidden p-0" align="start">
          <Calendar
            mode="single"
            selected={value}
            captionLayout="dropdown"
            onSelect={handleSelect}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}

export { DatePicker };
